<script>
    import { createEventDispatcher } from "svelte";
    import { clipboardStore } from "../../data/stores.js";
    import IconLink from "../icons/IconLink.svelte";

    // export let showLinkConverter = true; // New prop to control visibility

    let inputUrl = '';
    let result = '';

    // Enable/disable button based on whether inputUrl has a value
    $: isDisabled = inputUrl === '';

    function convert() {
        console.log('[LinkConverter] Convert button clicked');
        console.log('[LinkConverter] inputUrl:', inputUrl);
        result = 'https://libproxy.pcc.edu/login?url=' + inputUrl;
        console.log('[LinkConverter] result after conversion:', result);
    }

    const dispatch = createEventDispatcher();

    const handleClick = () => {
        console.log('[LinkConverter] Copy button CLICKED - handleClick fired');
        console.log('[LinkConverter] result value:', result);
        console.log('[LinkConverter] Setting clipboardStore to:', result);
        clipboardStore.set(result); // Set the result in the store
        console.log('[LinkConverter] clipboardStore.set() completed');
    };

    function clearInputUrl() {
        console.log('[LinkConverter] Clear button clicked');
        inputUrl = '';
        result = '';
    }
</script>

<!--{#if showLinkConverter} &lt;!&ndash; Conditional rendering based on the new prop &ndash;&gt;-->
    <div class="form-group w-100 border-top p-0 pt-4">
        <div class="form-group mr-2 w-100">
            <label for="input-url" class="mr-2"><b>Link Converter</b></label>
            <textarea id="input-url" class="form-control w-100" rows="3" bind:value={inputUrl}></textarea>
            <small id="input-url-help" class="form-text text-muted">Paste the URL you want to convert for linking.</small>
        </div>

        <button type="button"
                class="btn btn-primary"
                on:click={convert}
                disabled={isDisabled}>Convert</button>
        <button type="button"
                class="btn btn-info text-black align-self-start ml-2"
                on:click={clearInputUrl}
                disabled={isDisabled}>Clear</button>
    </div>

    {#if result}
        <p class="mt-3 mr-2 d-flex justify-content-start align-items-center mr-2">Converted URL:&nbsp;&nbsp;
            <button
                    title="Click to copy URL to clipboard"
                    aria-label="Click to copy URL to clipboard"
                    class="small btn bg-cyan text-white btn-sm d-flex justify-content-start align-items-center rounded-2"
                    on:click={handleClick}>

                <IconLink
                        class="ml-2"
                        width=".8rem"
                        height=".8rem"
                        fill="#fff"
                        padding="--padding-form"
                />
                <code class="text-white">{result}</code>
                <span class="sr-only"> Click to copy URL to clipboard</span>
            </button>
        </p>
    {/if}
